(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aktionen"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ht24-actions-slider')) {
    customElements.define('ht24-actions-slider', class extends HTMLElement {
      connectedCallback() {
        this.start = () => {
          if (!this.isConnected || this.events) return;
          this.events = new AbortController();
          const options = { signal: this.events.signal };
          this.offset = 0;
          this.limit = Math.max(1, Number(this.dataset.limit) || 4);
          this.cards = Array.from(this.querySelectorAll('.actions-card'));
          this.section = this.closest('section');
          this.navigation = this.section.querySelector('[data-action-navigation]');
          this.previous = this.section.querySelector('[data-action-previous]');
          this.next = this.section.querySelector('[data-action-next]');
          this.reducedMotion = Boolean(window.matchMedia?.('(prefers-reduced-motion: reduce)').matches);
          this.refill = () => {
            const now = Date.now();
            this.validCards = this.cards.filter(card => {
              const end = Number(card.dataset.end) * 1000;
              return !(Number.isFinite(end) && end > 0 && end <= now);
            });
            const count = this.validCards.length;
            this.offset = count > this.limit ? ((this.offset % count) + count) % count : 0;
            const visible = new Map();
            for (let i = 0; i < Math.min(this.limit, count); i += 1) {
              visible.set(this.validCards[(this.offset + i) % count], i);
            }
            this.cards.forEach(card => {
              card.hidden = !visible.has(card);
              card.style.order = visible.has(card) ? String(visible.get(card)) : '';
            });
            if (this.navigation) this.navigation.hidden = count <= this.limit;
          };
          this.tick = () => {
            this.refill();
            const now = Date.now();
            const hoursSetting = Number(this.dataset.countdownHours);
            const windowHours = Number.isFinite(hoursSetting) ? hoursSetting : 24;
            this.querySelectorAll('.actions-countdown').forEach(counter => {
              const end = Number(counter.dataset.end) * 1000;
              const remaining = end - now;
              const visible = Number.isFinite(end) && end > 0 && remaining > 0
                && counter.dataset.show === 'true'
                && (windowHours === 0 || remaining <= windowHours * 3600000);
              counter.hidden = !visible;
              if (!visible) return;
              const output = counter.querySelector('.actions-countdown-time');
              if (!output) return;
              const total = Math.ceil(remaining / 1000);
              const hours = Math.floor(total / 3600);
              const minutes = Math.floor(total % 3600 / 60);
              const seconds = total % 60;
              const pad = value => String(value).padStart(2, '0');
              output.textContent = `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
              output.setAttribute('aria-label', `${hours} Stunden, ${minutes} Minuten, ${seconds} Sekunden verbleibend`);
            });
          };
          this.move = direction => {
            this.refill();
            if (this.validCards.length <= this.limit) return;
            this.offset += direction * this.limit;
            this.tick();
          };
          this.restartRotation = () => {
            window.clearInterval(this.rotationTimer);
            const seconds = Number(this.dataset.interval);
            if (this.dataset.rotate !== 'true' || !Number.isFinite(seconds) || seconds < 5 || seconds > 30) return;
            this.rotationTimer = window.setInterval(() => {
              if (this.reducedMotion || document.hidden || this.section.matches(':hover') || this.section.contains(document.activeElement)) return;
              this.move(1);
            }, seconds * 1000);
          };
          this.previous?.addEventListener('click', () => { this.move(-1); this.restartRotation(); }, options);
          this.next?.addEventListener('click', () => { this.move(1); this.restartRotation(); }, options);
          document.addEventListener('visibilitychange', this.tick, options);
          this.tick();
          this.querySelectorAll('[data-countdown-diagnostic]').forEach(note => {
            const counter = note.closest('.actions-card')?.querySelector('.actions-countdown');
            if (counter && !counter.hidden) note.textContent = 'Countdown aktiv – wird sekündlich aktualisiert.';
          });
          this.clock = window.setInterval(this.tick, 1000);
          this.restartRotation();
        };
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', this.start, { once: true });
        } else {
          queueMicrotask(this.start);
        }
      }
      disconnectedCallback() {
        document.removeEventListener('DOMContentLoaded', this.start);
        this.events?.abort();
        this.events = null;
        window.clearInterval(this.clock);
        window.clearInterval(this.rotationTimer);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  if (!customElements.get('ht24-product-countdown')) {
    customElements.define('ht24-product-countdown', class extends HTMLElement {
      connectedCallback() {
        this.start = () => {
          if (!this.isConnected || this.timer) return;
          const deadline = Number(this.dataset.end) * 1000;
          const output = this.querySelector('.ht24-product-countdown-time');
          if (!Number.isFinite(deadline) || deadline <= 0 || !output) {
            this.hidden = true;
            return;
          }
          this.refresh = () => {
            const hoursSetting = Number(this.dataset.hours);
            const hoursWindow = Number.isFinite(hoursSetting) ? hoursSetting : 24;
            const remaining = deadline - Date.now();
            const visible = remaining > 0 && (hoursWindow === 0 || remaining <= hoursWindow * 3600000);
            this.hidden = !visible;
            if (visible) {
              const total = Math.ceil(remaining / 1000);
              const hours = Math.floor(total / 3600);
              const minutes = Math.floor(total % 3600 / 60);
              const seconds = total % 60;
              const pad = value => String(value).padStart(2, '0');
              output.textContent = `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
              output.setAttribute('aria-label', `${hours} Stunden, ${minutes} Minuten, ${seconds} Sekunden verbleibend`);
              const note = this.closest('.product-details-price')?.querySelector('[data-product-countdown-diagnostic]');
              if (note) note.textContent = 'Countdown aktiv – wird sekündlich aktualisiert.';
            }
            if (remaining <= 0) {
              window.clearInterval(this.timer);
              this.timer = null;
            }
            return remaining > 0;
          };
          document.addEventListener('visibilitychange', this.refresh);
          if (this.refresh()) this.timer = window.setInterval(this.refresh, 1000);
        };
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', this.start, { once: true });
        } else {
          queueMicrotask(this.start);
        }
      }
      disconnectedCallback() {
        document.removeEventListener('DOMContentLoaded', this.start);
        if (this.refresh) document.removeEventListener('visibilitychange', this.refresh);
        window.clearInterval(this.timer);
        this.timer = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
